import axios from "../routers/axios";

let struct = {

	data() {
		return {
			map: null,
			markerInicio: null,
			trilhas: [],
			markers: [],
			circles: [],
			clientes: [],
			equipamentos: []
		}
	},

	mounted() {
		axios.get(this._getUrl("api/equipamento")).then(response => {
			this.equipamentos = response.data.map(item => {
				item._selecionado = false;
				return item;
			});

			axios.get(this._getUrl("api/cliente")).then(response => {
				this.clientes = response.data.map(item => {
					item._exibir = false;
					item.equipamentos = this.getEquipamentoByIdCliente(item.id);
					return item;
				});
			});
		});

	},

	methods: {
		// retorna um icone de um aviao, helicoptero, barco ou carro para exibir no mapa
		getIcon(tipo, movimento, direcao, stopIconPNG, clienteId) {

			let cliente = {}
			let iconStop = 'svg'

			this.clientes.forEach(checaCliente);

			function checaCliente(item) {
				if (item.id == clienteId)
					cliente = item
			}

			if (stopIconPNG) {
				iconStop = 'png'
			}

			var urlbase = 'https://services.followair.com.br/icones/'

			// aviao
			if (tipo == 'A') {
				urlbase += 'a/1/'
				if (cliente.cor) {
					urlbase += cliente.cor
				}

				else {
					urlbase += 'azul'
				}

				if (movimento == "Y") {
					urlbase += '/fly/' + direcao + '.svg?v=' + this._getVersao()
				} else {
					urlbase += '/stop/' + direcao + '.' + iconStop + '?v=' + this._getVersao()
				}
			}

			// helicoptero
			if (tipo == 'H') {
				urlbase += 'h/1/'

				if (cliente.cor) {
					urlbase += cliente.cor
				}

				else {
					urlbase += 'azul'
				}

				if (movimento == "Y") {
					urlbase += '/fly/' + direcao + '.svg?v=' + this._getVersao()
				} else {
					urlbase += '/stop/' + direcao + '.' + iconStop + '?v=' + this._getVersao()
				}
			}

			if (tipo == 'B') {
				urlbase += 'b/'

				if (movimento == "Y") {
					urlbase += 'azul/fly/' + direcao + '.gif?v=' + this._getVersao()
				} else {
					urlbase += 'azul/stop/' + direcao + '.gif?v=' + this._getVersao()
				}
			}

			if (tipo == 'C') {
				urlbase += 'c/1/'

				if (movimento == "Y") {
					urlbase += 'azul/fly/' + direcao + '.svg' 
				} else {
					urlbase += 'azul/stop/' + direcao + '.svg'
				}
			}


			return urlbase;
		},

		geraBotoesDeZoom(botoesDeZoom) {
			botoesDeZoom.style.margin = "10px";

			let botaoZoomMais = document.createElement('button');
			botaoZoomMais.className = 'btn btn-sm btn-light'
			botaoZoomMais.style.marginRight = '2px'
			botaoZoomMais.style.fontSize = '1.2rem'
			botaoZoomMais.style.paddingBottom = '0px'
			botaoZoomMais.style.paddingTop = '0px'
			botaoZoomMais.style.fontWeight = 'bold'
			botaoZoomMais.title = 'Zoom In'
			botaoZoomMais.innerHTML = '+'
			botoesDeZoom.appendChild(botaoZoomMais);

			let botaoZoomMenos = document.createElement('button');
			botaoZoomMenos.className = 'btn btn-sm btn-light'
			botaoZoomMenos.style.fontSize = '1.8rem'
			botaoZoomMenos.style.paddingBottom = '0px'
			botaoZoomMenos.style.paddingTop = '0px'
			botaoZoomMenos.style.fontWeight = 'bold'
			botaoZoomMenos.style.lineHeight = '1em'
			botaoZoomMenos.title = 'Zoom In'
			botaoZoomMenos.title = 'Zoom Out'
			botaoZoomMenos.innerHTML = '-'
			botoesDeZoom.appendChild(botaoZoomMenos);

			google.maps.event.addDomListener(botaoZoomMais, 'click', () => {
				this.map.setZoom(this.map.getZoom() + 1);
			});

			google.maps.event.addDomListener(botaoZoomMenos, 'click', () => {
				this.map.setZoom(this.map.getZoom() - 1);
			});
		},

		geraBotoesDeTipoDeMapa(botoesTipoDeMapa) {
			botoesTipoDeMapa.style.marginTop = '10px'

			let botaoMapa = document.createElement('button')
			botaoMapa.type = 'button'
			botaoMapa.style.border = '0px'
			botaoMapa.className = 'btn btn-sm btn-primary'
			botaoMapa.innerHTML = 'MAPA'
			botaoMapa.style.padding = '5px'
			botaoMapa.style.fontSize = '0.8rem'
			botaoMapa.style.marginRight = '2px'
			botoesTipoDeMapa.appendChild(botaoMapa)

			let botaoSatelite = document.createElement('button')
			botaoSatelite.type = 'button'
			botaoSatelite.style.border = '0px'
			botaoSatelite.className = 'btn btn-sm btn-light'
			botaoSatelite.innerHTML = 'SATELITE'
			botaoSatelite.style.padding = '5px'
			botaoSatelite.style.fontSize = '0.8rem'
			botoesTipoDeMapa.appendChild(botaoSatelite)


			botaoMapa.addEventListener('click', () => {
				if (botaoMapa.className == 'btn btn-sm btn-light') {
					botaoMapa.className = 'btn btn-sm btn-primary'
					botaoSatelite.className = 'btn btn-sm btn-light'
					this.map.setMapTypeId(google.maps.MapTypeId.TERRAIN)
				}
			})

			botaoSatelite.addEventListener('click', () => {
				if (botaoSatelite.className == 'btn btn-sm btn-light') {
					botaoSatelite.className = 'btn btn-sm btn-primary'
					botaoMapa.className = 'btn btn-sm btn-light'
					this.map.setMapTypeId(google.maps.MapTypeId.HYBRID)
				}
			})

		},

		geraBotaoOpenStreetMaps(botoesTipoDeMapa) {
			botoesTipoDeMapa.style.marginTop = '10px';
	
			let botaoOpenStreetMaps = document.createElement('button');
			botaoOpenStreetMaps.type = 'button';
			botaoOpenStreetMaps.style.border = '0px';
			botaoOpenStreetMaps.className = 'btn btn-sm btn-light';
			botaoOpenStreetMaps.innerHTML = ' OPEN STREET MAPS';
			botaoOpenStreetMaps.style.padding = '5px';
			botaoOpenStreetMaps.style.fontSize = '0.8rem';
			botaoOpenStreetMaps.style.paddingLeft = '5px';
			botoesTipoDeMapa.appendChild(botaoOpenStreetMaps);
	
			botaoOpenStreetMaps.addEventListener('click', () => {
					this.exibirMapa(2); 
			});
		},

		geraBotoesDeTipoDeMapaMobile(botoesTipoDeMapa) {

			botoesTipoDeMapa.style.margin = "60px 0px 0px 10px"
			botoesTipoDeMapa.style.marginTop = 'calc(env(safe-area-inset-top) + 60px)'
			let botaoMapa = document.createElement('button')
			botaoMapa.type = 'button'
			botaoMapa.style.border = '0px'
			botaoMapa.className = 'btn btn-sm btn-primary'
			botaoMapa.innerHTML = 'MAPA'
			botaoMapa.style.padding = '10px 11px'

			botaoMapa.style.fontSize = '0.8rem'
			botaoMapa.style.marginRight = '2px'
			botaoMapa.style.boxShadow = 'rgba(0, 0, 0, 0.298039) 0px 1px 4px -1px'

			botaoMapa.addEventListener('click', () => {
				if (botaoMapa.className == 'btn btn-sm btn-light') {
					botaoMapa.className = 'btn btn-sm btn-primary'
					botaoSatelite.className = 'btn btn-sm btn-light'
					this.map.setMapTypeId(google.maps.MapTypeId.TERRAIN)
				}
			})

			botoesTipoDeMapa.appendChild(botaoMapa)

			let botaoSatelite = document.createElement('button')
			botaoSatelite.type = 'button'
			botaoSatelite.style.border = '0px'
			botaoSatelite.className = 'btn btn-sm btn-light'
			botaoSatelite.innerHTML = 'SATÉLITE'
			botaoSatelite.style.padding = '10px 11px'
			botaoSatelite.style.fontSize = '0.8rem'
			botaoSatelite.style.boxShadow = 'rgba(0, 0, 0, 0.298039) 0px 1px 4px -1px'

			botaoSatelite.addEventListener('click', () => {
				if (botaoSatelite.className == 'btn btn-sm btn-light') {
					botaoSatelite.className = 'btn btn-sm btn-primary'
					botaoMapa.className = 'btn btn-sm btn-light'
					this.map.setMapTypeId(google.maps.MapTypeId.HYBRID)
				}
			})

			botoesTipoDeMapa.appendChild(botaoSatelite)
		},

		// adiciona os botões de zoom e alteração de mapa
		adicionaBotoes() {

			let botoesDeZoom = document.createElement('div')
			let botoesDeTipoDeMapa = document.createElement('div')
			let botaoSelecionarOpenStreenMaps = document.createElement('div')
			if (this._isMobile) {
				this.geraBotoesDeTipoDeMapaMobile(botoesDeTipoDeMapa)
				this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(botoesDeTipoDeMapa)
			} else {
				this.geraBotoesDeZoom(botoesDeZoom)
				this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(botoesDeZoom)

				this.geraBotoesDeTipoDeMapa(botoesDeTipoDeMapa)
				this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(botoesDeTipoDeMapa)
				
				this.geraBotaoOpenStreetMaps(botaoSelecionarOpenStreenMaps)
				this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(botaoSelecionarOpenStreenMaps)
			}
		},

		// instancia e inicia um mapa
		iniciaMapa(ref, lat, lng, zoom) {
			this.map = null

			let latLong = new google.maps.LatLng(Number(lat), Number(lng));

			let mapaConfig = {
				center: latLong,
				zoom: zoom,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				mapTypeControl: false,
				mapTypeControlOptions: {
					position: google.maps.ControlPosition.TOP_RIGHT
					//style : google.maps.MapTypeControlStyle.DROPDOWN_MENU
				},
				gestureHandling: this._isMobile ? 'greedy' : 'cooperative',
				fullscreenControl: false,
				zoomControl: false,
				zoomControlOptions: {
					position: google.maps.ControlPosition.BOTTOM_RIGTH
				},
				navigationControl: false,
				scrollwheel: true,
				streetViewControl: false,
			//	styles:[{"stylers": [{ "hue": "#005eff" },{ "gamma": 0.64 }]}]
			};

			this.map = new google.maps.Map(ref, mapaConfig)
		},

		// remove todas as trilhas/polylines do mapa
		removePolylines() {
			for (var j = 0; j < this.trilhas.length; j++) {
				this.trilhas[j].setMap(null);
			}

			this.trilhas = []
		},

		updateCircle(marker, item, p) {
			if (item.emMovimento == 'Y' && item._equipamento.idCliente !== 57) {
				var lt = Number(item.lat);
				var lg = Number(item.lng);

				var dataAgora = new Date().toLocaleString()

				var dataAgoraSplit = dataAgora.split(' ');
				var itemDataAgoraSplit = item.data.split(' ');

				dataAgoraSplit = dataAgoraSplit[1].split(':');
				itemDataAgoraSplit = itemDataAgoraSplit[1].split(':')


				if ((parseInt(dataAgoraSplit[1]) - parseInt(itemDataAgoraSplit[1]) >= 10)) {
					if (this.circles[p]) {
						this.circles[p].setCenter({ lat: lt, lng: lg })
						this.circles[p].setRadius(marker.icon.size.height * 20000 * 1 / this.map.getZoom())
					}
					else {
						var circle = new google.maps.Circle({
							strokeColor: "red",
							strokeOpacity: 0.8,
							//	strokeWeight: 10,
							map: this.map,
							radius: marker.icon.size.height * 20000 * 1 / this.map.getZoom(),
							fillColor: '#AA0000',
							fillOpacity: 0.25,
							center: { lat: Number(lt), lng: Number(lg) },
						});
						circle.bindTo('center', marker, 'position');

						this.circles[p] = circle
					}
				}

				else if ((parseInt(dataAgoraSplit[1]) - parseInt(itemDataAgoraSplit[1]) >= 5)) {
					if (this.circles[p]) {
						this.circles[p].setCenter({ lat: lt, lng: lg })
						this.circles[p].setRadius(marker.icon.size.height * 20000 * 1 / this.map.getZoom())
					}
					else {
						var circle = new google.maps.Circle({
							strokeColor: "orange",
							strokeOpacity: 0.8,
							//	strokeWeight: 10,
							map: this.map,
							radius: marker.icon.size.height * 20000 * 1 / this.map.getZoom(),
							fillColor: '#AA4C00',
							fillOpacity: 0.4,
							center: { lat: Number(lt), lng: Number(lg) },
						});
						circle.bindTo('center', marker, 'position');

						this.circles[p] = circle
					}
				}

				else if (this.circles[p] && parseInt(dataAgoraSplit[1]) - parseInt(itemDataAgoraSplit[1]) < 5) {
					this.circles[p].setOptions({ visible: false })
				}
			}

			else if (this.circles[p] && item.emMovimento == 'N') {
				this.circles[p].setOptions({ visible: false })
			}
		},

		adicionaCirculo(marker, item, p) {
			if (item.emMovimento == 'Y' && item._equipamento.idCliente !== 57) {
				var dataAgora = new Date().toLocaleString()

				var dataAgoraSplit = dataAgora.split(' ');
				var itemDataAgoraSplit = item.data.split(' ');

				dataAgoraSplit = dataAgoraSplit[1].split(':');
				itemDataAgoraSplit = itemDataAgoraSplit[1].split(':');

				if ((parseInt(dataAgoraSplit[1]) - parseInt(itemDataAgoraSplit[1]) >= 10)) {
					var circle = new google.maps.Circle({
						strokeColor: "red",
						strokeOpacity: 0.8,
						//	strokeWeight: 10,
						map: this.map,
						radius: marker.icon.size.height * 20000 * 1 / this.map.getZoom(),
						fillColor: '#AA0000',
						fillOpacity: 0.25,
						center: { lat: Number(item.lat), lng: Number(item.lng) },
					});
					circle.bindTo('center', marker, 'position');

					this.circles.push(circle)
				}

				else if ((parseInt(dataAgoraSplit[1]) - parseInt(itemDataAgoraSplit[1]) >= 5)) {
					var circle = new google.maps.Circle({
						strokeColor: "orange",
						strokeOpacity: 0.8,
						//	strokeWeight: 10,
						map: this.map,
						radius: marker.icon.size.height * 20000 * 1 / this.map.getZoom(),
						fillColor: '#AA4C00',
						fillOpacity: 0.4,
						center: { lat: Number(item.lat), lng: Number(item.lng) },
					});
					circle.bindTo('center', marker, 'position');

					this.circles.push(circle)
				}

				else {
					this.circles.push(null)
				}
			}

			else {
				this.circles.push(null)
			}
		},

		// remove todos os pontos do mapa
		removeMarkers() {
			for (var j = 0; j < this.markers.length; j++) {
				this.markers[j].setMap(null);
			}
		},

		// atualiza o centro do mapa
		atualizaMapa(lat, lng, zoom) {
			this.map.setCenter(new google.maps.LatLng(Number(lat), Number(lng)));
			this.map.setZoom(zoom);
		},

		// atualiza os markers das aeronaves
		atualizaMarker(item, p) {			

			for (var i in this.markers) {
				// acha a aeronave
				if (this.markers[i].id == item.imei && item._equipamento.idCliente !== 57) {
					var lt = Number(item.lat);
					var lg = Number(item.lng);

					// atualiza a lat e lng

					this.markers[i].setPosition({ lat: lt, lng: lg });

					this.markers[i].info.setContent(this.geraInfoView(item))

					let img = this.getIcon(item._equipamento.tipo, item.emMovimento, item.direcao, false, item._equipamento.idCliente)

					if (item.emMovimento == 'Y') {
						
						this.markers[i].setIcon(new google.maps.MarkerImage(
							img,
							new google.maps.Size(50, 50),
							new google.maps.Point(0, 0),
							new google.maps.Point(30, 30),
							new google.maps.Size(50, 50)
						));

						this.updateCircle(this.markers[i], item, p);
					}

					else {
						this.markers[i].setIcon(new google.maps.MarkerImage(
							img,
							new google.maps.Size(20, 20),
							new google.maps.Point(0, 0),
							new google.maps.Point(30, 30),
							new google.maps.Size(20, 20)
						));

						this.updateCircle(this.markers[i], item, p);
					}
				}
			}
		},

		// insere os markers das aeronaves
		insereMarker(item, p) {
			let myLatLng = { lat: Number(item.lat), lng: Number(item.lng) };

			if(item._equipamento.idCliente === 57)
				item._equipamento.tipo = 'C'

			let img = this.getIcon(item._equipamento.tipo, item.emMovimento, item.direcao, false, item._equipamento.idCliente)
			// gera o marker da aeronave
			if (item.emMovimento == 'Y' && item._equipamento.idCliente !== 57) {
				if (item.lat != 0) {
					let marker = new google.maps.Marker({
						position: myLatLng,
						id: item.imei,
						map: this.map,
						optimized: false,
						icon: new google.maps.MarkerImage(
							img,
							new google.maps.Size(50, 50),
							new google.maps.Point(0, 0),
							new google.maps.Point(30, 30),
							new google.maps.Size(50, 50)
						)
					});

					marker.info = new google.maps.InfoWindow({
						content: this.geraInfoView(item),
						maxWidth: 600
					})

					google.maps.event.addListener(
						marker,
						'click',
						((marker, p) => {
							return () => {
								this.clickAeroMapa(item.imei)
							}
						})(marker, p)
					)

					// add o evento qnado passa o mouse
					google.maps.event.addListener(
						marker,
						'mouseover',
						((marker, p) => {
							return () => {
								//	this.controleClicou = true // controle para não exibir o botão centralizar ao mudar o zoom
								marker.info.open(this.map, marker)
							}
						})(marker, p)
					)

					// add o vento quando sai o maou
					google.maps.event.addListener(
						marker,
						'mouseout',
						((marker, p) => {
							return () => {
								//	this.controleClicou = true // controle para não exibir o botão centralizar ao mudar o zoom
								marker.info.close(this.map, marker)
							}
						})(marker, p)
					)

					this.adicionaCirculo(marker, item, p);

					this.markers.push(marker);
				}
			}

			else {
				if (item.lat != 0 && item._equipamento.idCliente !== 57) {
					let marker = new google.maps.Marker({
						position: myLatLng,
						id: item.imei,
						map: this.map,
						optimized: false,
						icon: new google.maps.MarkerImage(
							img,
							new google.maps.Size(20, 20),
							new google.maps.Point(0, 0),
							new google.maps.Point(30, 30),
							new google.maps.Size(20, 20)
						)
					});
					marker.info = new google.maps.InfoWindow({
						content: this.geraInfoView(item),
						maxWidth: 600
					})

					google.maps.event.addListener(
						marker,
						'click',
						((marker, p) => {
							return () => {
								this.clickAeroMapa(item.imei)
							}
						})(marker, p)
					)

					google.maps.event.addListener(
						marker,
						'mouseover',
						((marker, p) => {
							return () => {
								//	this.controleClicou = true // controle para não exibir o botão centralizar ao mudar o zoom
								marker.info.open(this.map, marker)
							}
						})(marker, p)
					)

					// add o vento quando sai o maou
					google.maps.event.addListener(
						marker,
						'mouseout',
						((marker, p) => {
							return () => {
								//	this.controleClicou = true // controle para não exibir o botão centralizar ao mudar o zoom
								marker.info.close(this.map, marker)
							}
						})(marker, p)
					)

					this.adicionaCirculo(marker, item, p);

					this.markers.push(marker);
				}
			}
		},

		clickAeroMapa(imei) {
			if (imei != null) {

				this.limpaSelecionado()
				this.exibeMenu = false
				let equip = _.find(this.equipamentos, o => {
					return o.imei == imei;
				});

				this.clientes = this.clientes.map(item => {
					if (item.id == equip.idCliente) {
						this.cliente = item
					}

					item.equipamentos = item.equipamentos.map(equip => {
						if (equip.imei == imei) {
							equip._selecionado = true;
						}
						return equip;
					});
					return item;
				});

				this.posicaoAtual = _.find(this.posicoes, o => {
					return o.imei == imei;
				});

				this.posicaoAtual._cliente = _.find(this.clientes, c => { return c.id == this.posicaoAtual._equipamento.idCliente })

				this.aeroSelecionada = equip;

				this.removePolylines()
				this.centralizar = true;
				this.markerInicio.setMap(null);

				$webSocket.invoke("GetTilha", equip.imei, this.sessao.token).then(trilhas => {
					this.removePolylines()
					this.markerInicio.setMap(null)

					if (trilhas.length > 0) {
						this.geraTrilha(trilhas)
					}
				}).catch(err => {
					console.error("erro websoket", err.toString());
				});
				this.atualizaMapa(this.posicaoAtual.lat, this.posicaoAtual.lng, equip.tipo == "C" || equip.tipo == "B" ? 14 : 9);
			}
		},

		// gera a trilha de um voo
		geraTrilha(trilha) {
			let polyTrilha = [];
			let lista = [];

			if (trilha.length == 0) {
				this.markerInicio.setMap(null);
			} else {
				if (this.aeroSelecionada.tipo == "B" || this.aeroSelecionada.tipo == "C") {
					for (let i in trilha) {

						polyTrilha.push({ lat: Number(trilha[i].lat), lng: Number(trilha[i].lng) });

						// se for a primeira posicao, gera um pin
						if (Number(i) == 0) {
							if (this.markerInicio.getMap() == null) {
								this.markerInicio.setPosition(polyTrilha[0]);
								this.markerInicio.setMap(this.map);
							}
						}
					}

					// polyline com o movimento até o momento da aero
					let polylineLinhaConfig = new google.maps.Polyline({
						strokeColor: "#fd7e14",
						path: polyTrilha,
						strokeOpacity: 1,
						map: this.map
					});

					lista.push(polylineLinhaConfig);
				} else {
					for (let i in trilha) {
						polyTrilha.push({ lat: Number(trilha[i].lat), lng: Number(trilha[i].lng) });

						// se for a primeira posicao, gera um pin
						if (Number(i) == 0) {
							if (this.markerInicio.getMap() == null) {
								this.markerInicio.setPosition(polyTrilha[0]);
								this.markerInicio.setMap(this.map);
								// this.markerInicio.setIcon(new google.maps.MarkerImage(this._getPin('vermelho')));
							}
						}

						// polyline com o movimento até o momento da aero
						var polylineLinhaConfig = new google.maps.Polyline({
							strokeColor: "#fd7e14",
							path: polyTrilha,
							strokeOpacity: 1,
							icons: [{
								scale: 0.8,
								icon: { path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW },
								offset: "1"
							}],
							map: this.map
						});

						lista.push(polylineLinhaConfig);
					}
				}
			}
			this.trilhas = lista
		},

		geraPolylines(posicoes) {

			let polyTrilha = []

			for (var i in posicoes) {
				polyTrilha.push({ lat: Number(posicoes[i].lat), lng: Number(posicoes[i].lng) })
			}

			// polyline com o movimento
			let polylineLinhaConfig = new google.maps.Polyline({
				strokeColor: "#fd7e14",
				path: polyTrilha,
				strokeOpacity: 1,
				icons: [
					{
						scale: 0.8,
						icon: {
							path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
						},
						offset: "1",
						repeat: "90px"
					}
				]
			});

			polylineLinhaConfig.setMap(this.map)

			// add as poly na lista
			this.trilhas.push(polylineLinhaConfig);
		},

		geraMarkers(posicoes) {
			let lenghPlots = posicoes.length
			// let polyTrilha = []

			for (let i in posicoes) {
				// polyTrilha.push({lat: Number(posicoes[i].lat),lng: Number(posicoes[i].lng)})

				this.geraMarker(posicoes[i], Number(i), lenghPlots)
			}
		},

		// Gera o rastro da aeronave
		geraMarker(item, i, lenghPlots) {
			let strginInfo = "";
			let marker = null;
			let img = "";

			if (i == 0) {
				img = new google.maps.MarkerImage("https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_greenI.png");

				strginInfo = "<table style='width:100%'>";
				strginInfo += "<tr style='border-bottom:1px solid #F0F0F0'>";
				strginInfo += "<td style='padding:1px 10px 10px 10px;color: #1976D2; font-size:14px'>";
				strginInfo += "<strong>INICIO</strong>";
				strginInfo += "</td></tr>";
			} else if (i == lenghPlots - 1) {
				img = new google.maps.MarkerImage("https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_blueF.png");

				strginInfo = "<table style='width:100%'>";
				strginInfo += "<tr style='border-bottom:1px solid #F0F0F0'>";
				strginInfo += "<td style='padding:1px 10px 10px 10px;color: #1976D2; font-size:14px'>";
				strginInfo += "<strong>FIM</strong>";
				strginInfo += "</td></tr>";
			} else {

				img = new google.maps.MarkerImage(
					this.getIcon(this.form.equipamento.tipo, "N", item.direcao, true, this.form.equipamento.idCliente),
					null, //new google.maps.Size(65, 65, "px", "px"),
					null, // new google.maps.Point(0, 0),
					new google.maps.Point(20, 20),
					new google.maps.Size(40, 40)
				);

				strginInfo = "<table style='width:100%'>";
				strginInfo += "<tr style='border-bottom:1px solid #F0F0F0'>";
				strginInfo += "<td style='padding:1px 10px 10px 10px;color: #1976D2; font-size:14px'>";
				strginInfo += "<strong>POSIÇÃO " + (i + 1) + " " + "</strong>";
				strginInfo += "</td></tr>";
			}

			// informacoes de posicoes
			strginInfo += "<tr>";
			strginInfo += "<td style='padding:10px'>";
			strginInfo += "<table>";
			strginInfo += "<tr><td class='pd-table-gmap-aero'><strong>DATA</strong>: </td><td class='pd-table-gmap-aero'>" + item.data + "</td></tr>";
			strginInfo += "<tr><td class='pd-table-gmap-aero'><strong>UTC</strong>: </td><td class='pd-table-gmap-aero'>" + item._dataUTC + "</td></tr>";
			strginInfo += "<tr><td class='pd-table-gmap-aero'><strong>VELOCIDADE</strong>: </td><td class='pd-table-gmap-aero'>" + item.velocidade + "</td></tr>";
			strginInfo += "<tr><td class='pd-table-gmap-aero'><strong>ALTITUDE</strong>: </td><td class='pd-table-gmap-aero'>" + item.altitude + "</td></tr>";
			strginInfo += "<tr><td class='pd-table-gmap-aero'><strong>DIREÇÃO</strong>: </td><td class='pd-table-gmap-aero'>" + item.direcao + "</td></tr>";
			strginInfo += "<tr><td class='pd-table-gmap-aero'><strong>LAT</strong>: </td><td class='pd-table-gmap-aero'>" + item.lat + "</td></tr>";
			strginInfo += "<tr><td class='pd-table-gmap-aero'><strong>LNG</strong>: </td><td class='pd-table-gmap-aero'>" + item.lng + "</td></tr>";
			strginInfo += "</table>";
			strginInfo += "</td>";

			strginInfo += "</tr>";
			strginInfo += "</table>";

			// console.log(img)

			var myLatLng = { lat: Number(item.lat), lng: Number(item.lng) };

			marker = new google.maps.Marker({
				position: myLatLng,
				map: this.map,
				options: {
					icon: img,
					animation: i == 0 || i == lenghPlots - 1 ? google.maps.Animation.DROP : null
				}
			});

			// gera o info view na aeronave
			marker.info = new google.maps.InfoWindow({ content: strginInfo });

			// add o evento qnado passa o mouse
			google.maps.event.addListener(marker, "mouseover", ((marker, i) => {
				return () => {
					marker.info.open(this.map, marker);
				};
			})(marker, i))

			// add o vento quando sai o maou
			google.maps.event.addListener(marker, "mouseout", ((marker, i) => {
				return () => {
					marker.info.close(this.map, marker);
				};
			})(marker, i));

			this.markers.push(marker);
		},

		// centraliza o mapa através de algumas posicoes
		fitBounds(bounds) {
			this.map.fitBounds(bounds)
		},

		fitBoundsList(posicoes) {
			let bounds = new google.maps.LatLngBounds()
			let polyTrilha = []

			for (var i in posicoes) {
				polyTrilha.push({ lat: Number(posicoes[i].lat), lng: Number(posicoes[i].lng) });
				bounds.extend(polyTrilha[i]);
			}

			this.fitBounds(bounds)
		}
	}
}

export default struct



// WEBPACK FOOTER //
// ./src/library/mapa.js